import React from "react";
import ReactDOM from "react-dom";
import './GlobalDisclaimer.scss'

const GlobalDisclaimer = ({ ui }) => {
  const disclaimerText =
    window.selectedConfig.currentGlobalDisclaimer !== undefined
      ? window.selectedConfig.currentGlobalDisclaimer
      : ui.globalDisclaimer;

  return ReactDOM.createPortal(
    <div id="disclaimer">
      {disclaimerText}
    </div>,
    document.getElementById("globalDisclaimer")
  );
};

export default GlobalDisclaimer;